'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./table-header-cell.css');

var _tableCell = require('../table-cell/table-cell');

var _tableCell2 = _interopRequireDefault(_tableCell);

var _ = require('../../');

var _models = require('../../../models');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GeckoTableHeaderCell = function (_GeckoTableCell) {
	_inherits(GeckoTableHeaderCell, _GeckoTableCell);

	function GeckoTableHeaderCell() {
		_classCallCheck(this, GeckoTableHeaderCell);

		return _possibleConstructorReturn(this, (GeckoTableHeaderCell.__proto__ || Object.getPrototypeOf(GeckoTableHeaderCell)).apply(this, arguments));
	}

	_createClass(GeckoTableHeaderCell, [{
		key: 'renderAriaLabel',
		value: function renderAriaLabel() {
			return this.col().ariaLabel || this.col().name || null;
		}
	}, {
		key: 'renderSrOnly',
		value: function renderSrOnly() {
			if (!this.col().name && this.renderAriaLabel()) {
				return _react2.default.createElement(
					'span',
					{ className: 'sr-only' },
					this.renderAriaLabel()
				);
			}
			return null;
		}
	}, {
		key: 'sortKey',
		value: function sortKey() {
			if (this.col().sortable && typeof this.col().sortable === 'string') {
				return this.col().sortable;
			} else if (this.col().sortable) {
				return this.col().key;
			}
			return false;
		}
	}, {
		key: 'pagination',
		value: function pagination() {
			return this.props.pagination;
		}
	}, {
		key: 'isSortable',
		value: function isSortable() {
			return this.sortKey() && this.pagination().changeOrder;
		}
	}, {
		key: 'sortHandler',
		value: function sortHandler() {
			if (this.isSortable()) {
				return this.pagination().changeOrder(this.sortKey());
			}
			return;
		}
	}, {
		key: 'isOrdered',
		value: function isOrdered() {
			return this.pagination().order === this.sortKey();
		}
	}, {
		key: 'isAsc',
		value: function isAsc() {
			return (this.pagination().sort || '').toLowerCase() === 'asc';
		}
	}, {
		key: 'isDesc',
		value: function isDesc() {
			return (this.pagination().sort || '').toLowerCase() === 'desc';
		}
	}, {
		key: 'renderActiveSortIcon',
		value: function renderActiveSortIcon() {
			if (this.isOrdered()) {
				var icon = this.isDesc() ? 'sort-desc' : 'sort-asc';
				return _react2.default.createElement(_.GeckoIcon, { icon: icon });
			}
			return null;
		}
	}, {
		key: 'renderSortControls',
		value: function renderSortControls() {
			if (this.isSortable()) {
				return _react2.default.createElement(
					'span',
					{ className: 'pull-right' },
					_react2.default.createElement(_.GeckoIcon, { icon: 'sort' }),
					this.renderActiveSortIcon()
				);
			}
			return null;
		}
	}, {
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				'th',
				{ 'aria-label': this.renderAriaLabel(), className: this.renderClasses(true), style: this.renderStyles(), onClick: this.sortHandler.bind(this) },
				this.col().name,
				this.renderSrOnly(),
				this.renderSortControls()
			);
		}
	}]);

	return GeckoTableHeaderCell;
}(_tableCell2.default);

GeckoTableHeaderCell.defaultProps = {
	col: {},
	pagination: {}
};

GeckoTableHeaderCell.propTypes = {
	col: _propTypes2.default.shape(_models.GeckoTableCellModel).isRequired,
	pagination: _propTypes2.default.shape(_models.GeckoPaginationModel)
};

exports.default = GeckoTableHeaderCell;
